// extracted by css-extract-rspack-plugin
export default {"copyJobErrorJobId":"copyJobErrorJobId-iFy1nh","copyJobErrorMessage":"copyJobErrorMessage-dXx2kO"};